// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Loader","loader":"Loader","load8":"load8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Loader.scss
// module id = 426
// module chunks = 0